module.exports = __webpack_public_path__ + "img/storage-4.06cde92e.jpg";